/* eslint import/prefer-default-export: 0 */

// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const getDeployments = CreateProcess({
	method: "GET",
	name: "getDeployments",
	type: "DEPLOYMENTS:GET",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/deployments/`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const teardownDeployment = CreateProcess({
	method: "DELETE",
	name: "teardownDeployment",
	type: "DEPLOYMENTS:DELETE",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/deployments/`,
			payload: props.payload,
		};
	},

	success: (response) => {
		console.log("success", response);
		return fromJS(response.data);
	},

	error: (response) => {
		console.log("error", response);
		return fromJS(response.data);
	},
});

export const getDeploymentInfo = CreateProcess({
	method: "GET",
	name: "getDeploymentInfo",
	type: "DEPLOYMENTS:INFO",

	request: (props) => ({
		cancelBaseUrl: true,
		url: `https://${props.domain}.talent.performyard.com/health/`,
	}),

	success: (response) => {
		console.log("success", response);
		return fromJS(response.data);
	},

	error: (response) => {
		console.log("error", response);
		return fromJS(response.data);
	},
});

export const deployBranch = CreateProcess({
	method: "POST",
	name: "deployBranch",
	type: "DEPLOYMENTS:CREATE",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/deployments/`,
			payload: props.payload,
		};
	},

	success: (response) => {
		console.log("success", response);
		return fromJS(response.data);
	},

	error: (response) => {
		console.log("error", response);
		return fromJS(response.data);
	},
});

export const updateDeployment = CreateProcess({
	method: "POST",
	name: "updateDeployment",
	type: "DEPLOYMENTS:UPDATE",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/deployment-update/`,
			payload: props.payload,
		};
	},

	success: (response) => {
		console.log("success", response);
		return fromJS(response.data);
	},

	error: (response) => {
		console.log("error", response);
		return fromJS(response.data);
	},
});
